module.exports = __webpack_public_path__ + "src/assets/img/05.bea98d88.png";